import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface ChevronIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Chevron icon using SF Pro font symbol (􀆈)
 *
 * This icon represents the expand/collapse action in expandable components,
 * typically rotated to indicate state (down for collapsed, up for expanded).
 *
 * @example
 * ```tsx
 * <ChevronIcon />
 * <ChevronIcon size={16} weight="semibold" />
 * <ChevronIcon className="rotate-180" /> // For expanded state
 * ```
 */
export const ChevronIcon = React.forwardRef<HTMLSpanElement, ChevronIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀆈" {...props} />
  }
)

ChevronIcon.displayName = "ChevronIcon"